import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home.vue'
import Consult from '@/components/Consult.vue'
import AboutUs from '@/components/AboutUs.vue'
import Login from '@/components/Login.vue'
import Password from '@/components/Password.vue'
import My from '@/components/My.vue'
import Buy from '@/components/Buy.vue'
import Order from '@/components/Order.vue'
import Sell from '@/components/Sell.vue'
import HomeTv from '@/components/HomeTv.vue'
import MetalsHomeTv from '@/components/MetalsHomeTv.vue'
import Metals from '@/components/Metals.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    {
      path: '/HomeTv',
      name: 'HomeTv',
      component: HomeTv
    },
    {
      path: '/Consult',
      name: 'Consult',
      component: Consult
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Password',
      name: 'Password',
      component: Password
    },
    {
      path: '/My',
      name: 'My',
      component: My
    },
    {
      // 销售主页
      path: '/Buy',
      name: 'Buy',
      component: Buy
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    },
    {
      // 回购
      path: '/Sell',
      name: 'Sell',
      component: Sell
    },
    {
      path: '/Metals',
      name: 'Metals',
      component: Metals
    },
    // ************* web-home
    {
      path: '/',
      name: 'Metals',
      component: Metals
    },
    {
      path: '/Home',
      name: 'Home',
      component: Metals
    },
    // *************
    {
      path: '/MetalsHomeTv',
      name: 'MetalsHomeTv',
      component: MetalsHomeTv
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js